import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { isFunction } from "../../utils";
import { Autocomplete, TextField, FormControl } from "@mui/material";

const SearchDropdown = (props) => {
  const { t } = useTranslation("translation");
  let { error } = props;
  const {
    rows,
    label,
    onChange,
    labelColumn = "label",
    valueColumn = "value",
    selectedValue = null,
    className,
  } = props;

  if (error !== undefined && error !== null) {
    error = t("errors." + error);
  } else {
    error = null;
  }

  // Prepare options
  const options = Array.from(
    rows.map((row) => ({
      value: row[valueColumn],
      label: row[labelColumn],
      template: row.template,
    }))
  ).sort((a, b) => a.label.localeCompare(b.label));

  // Find initial value object
  //const initialSelected = options.find((opt) => opt.value === selectedValue) || null;

  const selected = options.find((opt) => opt.value === selectedValue) || null;

  const handleChange = (_, newValue) => {
    const valueToSet = newValue || { value: "", label: "" };
    if (isFunction(onChange)) {
      onChange({ target: valueToSet });
  }
  };

  return (
    <FormControl
      className={`comp-dropdown-container ${className ? "container-" + className : ""} ${
        error ? "error" : ""
      }`}
      fullWidth
    >
      <Autocomplete
        options={options}
        value={selected && selected.value !== "" ? selected : null}
        onChange={handleChange}
        disableClearable={false}
        clearOnEscape
        getOptionLabel={(option) => option.label || ""}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"    
            error={Boolean(error)}
            slotProps={{inputLabel: { shrink: true }}}
            helperText={error}
            InputProps={{
              ...params.InputProps,
              style: { fontSize: 14, fontFamily: "Baloo 2, sans-serif;", height: 39 },
            }}
            sx={{'& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: '#404CE2',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#007FFF',
                },
                '&.Mui-focused fieldset': {
                    borderColor: '#0066cc', 
                    borderWidth: 1,
                }
            }}}
          />
        )}
      />
    </FormControl>
  );
};

SearchDropdown.propTypes = {
  labelColumn: PropTypes.string,
  valueColumn: PropTypes.string,
  label: PropTypes.string,
  rows: PropTypes.array.isRequired,
  error: PropTypes.string,
  hasEmptyOption: PropTypes.bool,
  onChange: PropTypes.func,
  selectedValue: PropTypes.string,
  className: PropTypes.string,
};

export { SearchDropdown };
